// Reducers
import { reducer as toastrReducer } from 'react-redux-toastr';
// import localizationReducer from './localization';
// import mapReducer from './map';
// import filterReducer from './filter';
// import authReducer from './auth';
// import toasterReducer from './toaster';
// import appResetReducer from './appReset';
// import refreshTimeReducer from './refreshTime';

// Action Creators
//export { dispatchActionFromSocket } from './socket';
export { navigateTo, navigateBack, navigateForward } from './connectedRouter';

const appReducers = {
  //intl: localizationReducer,
  //map_v2: mapReducer,
  //filter: filterReducer,
  //auth: authReducer,
  //toasterReducer,
  toastr: toastrReducer,
 // appReset: appResetReducer,
  //refreshTime: refreshTimeReducer,
};

export default appReducers;
